var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUserMd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_user-md",
    "data-name": "Icon / user-md",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.994,
    height: 16,
    viewBox: "0 0 13.994 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-md",
    d: "M7,8A4,4,0,1,0,3,4,4,4,0,0,0,7,8ZM7,1A3,3,0,1,1,4,4,3,3,0,0,1,7,1ZM9.928,9C8.872,8.972,8.544,9.5,7,9.5S5.131,8.972,4.075,9A4.2,4.2,0,0,0,0,13.2v2.55A.251.251,0,0,0,.25,16h.5A.251.251,0,0,0,1,15.75V13.2a3.2,3.2,0,0,1,3-3.181v2.553a1.75,1.75,0,1,0,1,0v-2.4a6.259,6.259,0,0,0,4,0v2.15a2.08,2.08,0,0,0-1.5,2.019v.912a.5.5,0,0,0,.147.353l.322.322a.251.251,0,0,0,.353,0l.353-.353a.251.251,0,0,0,0-.353L8.5,15.041V14.25a1,1,0,0,1,1.169-.988A1.04,1.04,0,0,1,10.5,14.3v.738l-.178.178a.251.251,0,0,0,0,.353l.353.353a.251.251,0,0,0,.353,0l.322-.322a.5.5,0,0,0,.147-.353v-1a1.994,1.994,0,0,0-1.5-1.925v-2.3a3.2,3.2,0,0,1,3,3.181V15.75a.251.251,0,0,0,.25.25h.5a.251.251,0,0,0,.25-.25V13.2A4.188,4.188,0,0,0,9.928,9ZM5.25,14.25a.75.75,0,1,1-.75-.75A.752.752,0,0,1,5.25,14.25Z",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUserMd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - user-md.ebf655d1cdb74549a674baf4834f7adb.svg";